'use client';
/**
 * FooterTalkLink — 푸터의 「부정공 카톡방」 골드 링크 (SiteFooter 의 열 extra 슬롯용 클라이언트 섬).
 *
 * 링크·계측은 기존 체계 그대로: KAKAO_TALK_URL(lib/talk-banner — 상수 단일 출처) ·
 * 노출 useTalkView('footer') · 클릭 trackTalkClick('footer'). 옛 FooterTalkBanner 와 «같은 슬롯» 이다
 * — 새 이벤트명·새 슬롯을 만들지 않는다(§1-4 「기존 명명 규칙」).
 * ⚠️ 옛 FooterTalkBanner 와 한 페이지에 동시에 두지 말 것 — 노출이 두 번 센다.
 * SSR HTML 은 방문자와 무관하게 같다(훅은 이펙트에서만 돈다).
 */
import { KAKAO_TALK_URL, trackTalkClick } from '@/lib/talk-banner';
import { useTalkView } from '@/components/banner/useTalkView';

export default function FooterTalkLink({ label = '부정공 카톡방' }: { label?: string }) {
  const ref = useTalkView<HTMLAnchorElement>('footer');
  return (
    <a
      ref={ref}
      href={KAKAO_TALK_URL}
      target="_blank"
      rel="noopener noreferrer"
      className="e-footer__talk"
      onClick={() => trackTalkClick('footer')}
      aria-label={`${label} — 오픈 카톡방, 새 창으로 열기`}
    >
      {label}
    </a>
  );
}
